import dayjs from 'dayjs'
import { useStore } from '../store/hooks'

export const useUser = () => {
  const auth = useStore(s => s.auth)
  const user = auth?.user

  const location = useStore(s => s.location)
  const selectedStore = useStore(s => s.store.selectedStore)

  const isCamelCard =
    selectedStore?.region === 'SA' ||
    selectedStore?.region === 'NT' ||
    user?.camelCardID ||
    user?.camelCardNumber ||
    location?.region === 'SA' ||
    location?.region === 'NT'

  let isBirthdayToday = null
  let isWithin14DaysAfterBirthday = null

  if (user) {
    const today = dayjs(new Date())
    let birthday = dayjs(user.dateOfBirth).set('year', today.get('year'))

    // If birthday hasn't occurred yet this year, use last year's birthday
    // This handles cases where we're in early January but birthday is in December
    if (today.isBefore(birthday)) {
      birthday = birthday.subtract(1, 'year')
    }

    const twoWeeksAfterBirthday = birthday.add(2, 'week')

    isBirthdayToday = birthday.format('MM-DD') === today.format('MM-DD')

    isWithin14DaysAfterBirthday =
      birthday.format('MM-DD') === today.format('MM-DD') ||
      (today.isAfter(birthday) && today.isBefore(twoWeeksAfterBirthday)) ||
      twoWeeksAfterBirthday.format('MM-DD') === today.format('MM-DD')
  }

  const isLoggedIn = !!user

  return {
    user,
    isLoggedIn,
    isCamelCard,
    token: auth?.token,
    isBirthdayToday,
    isWithin14DaysAfterBirthday,
  }
}
